import moment from 'moment';
import datesMethods from './datesMethods';

const habitHelpers = {
  createHabit(habit) {
    if (habit) return null;
    return null;
  },
  isHabitDoneForDay: (day, habit) => {
    const logsForHabitForDay = habit.logs?.filter((log) => datesMethods.$isSame(
      day,
      log.date,
    ));
    const valueForDone = habit.valueToDone || 1;
    const isDone = (logsForHabitForDay?.length ? logsForHabitForDay.length : 0) >= valueForDone;
    return { isDone, valueForDone, logsValue: logsForHabitForDay.length };
  },
  getStatsFromToForHabit: (habit, days) => {
    let coundSucces = 0;
    const count = days.length;
    const habitObject = { ...habit };

    days.forEach((day) => {
      const { isDone } = habitHelpers.isHabitDoneForDay(day, habitObject);
      if (isDone) coundSucces += 1;
    });

    return {
      coundSucces,
      count,
    };
  },
  createSeriesForHabit: (habit) => {
    let seriesCount = 0;
    const today = moment();
    const habitObject = { ...habit };
    datesMethods.$getDaysFromNow(30).some((el) => {
      const { isDone } = habitHelpers.isHabitDoneForDay(el, habitObject);
      if (isDone) seriesCount += 1;
      return datesMethods.$isSame(today, el) ? false : !isDone;
    });

    return seriesCount;
  },
  activeHabits: (day, habitsWithLogs) => habitsWithLogs.filter((habit) => {
    const createdToSelectedDate = moment(day).startOf('day').diff(moment(habit.created).startOf('day'), 'days');
    const endDateToSelectedDate = moment(day).startOf('day').diff(moment(habit.endDate).startOf('day'), 'days');
    const isActive = (createdToSelectedDate >= 0) && (habit.endDate
      ? (endDateToSelectedDate < 0) : true);

    return isActive;
  }),
  getHabitStatsForDay: (day, habitsWithLogs) => {
    const activeHabitsWithStatusPerDay = habitHelpers.activeHabits(day, habitsWithLogs)
      .map((habit) => (
        { ...habit, isDone: habitHelpers.isHabitDoneForDay(day, habit).isDone }));
    const habitsDone = activeHabitsWithStatusPerDay.filter((habit) => habit.isDone).length;
    const allActiveHabitsCount = activeHabitsWithStatusPerDay.length;
    const habitsNotDone = allActiveHabitsCount - habitsDone;
    const isDayDone = habitsDone === allActiveHabitsCount;

    return {
      habitsDone,
      habitsNotDone,
      isDayDone,
      allActiveHabitsCount,
    };
  },
};

export default habitHelpers;
